(function () {
class $5c3ab28d7e637dfc$export$5087227eb54526 {
    static listeners = [];
    static event(eventID, params = null) {
        console.log(`EventBus.event(${eventID}, ${params})`);
        $5c3ab28d7e637dfc$export$5087227eb54526.listeners.forEach((listener)=>{
            if (listener.eventID === eventID) {
                if (params) listener.callback(params);
                else listener.callback();
            }
        });
    }
    static addListener(eventID, callback) {
        const listener = new this.Listener(eventID, callback);
        return listener;
    }
    static Listener = class Listener {
        constructor(eventID, callback){
            this.eventID = eventID;
            this.callback = callback;
            $5c3ab28d7e637dfc$export$5087227eb54526.listeners.push(this);
        }
        remove() {
            const index = $5c3ab28d7e637dfc$export$5087227eb54526.listeners.indexOf(this);
            $5c3ab28d7e637dfc$export$5087227eb54526.listeners.splice(index, index !== -1 ? 1 : 0);
        }
    };
}


class $002442a081a20f94$export$af73ab700e00763e {
    static delayedFadeIn(element, milliseconds = 0, scrollTo = false) {
        if (!element) return;
        element.classList.add("fade-out");
        setTimeout(()=>{
            element.classList.remove("d-none");
            element.classList.remove("fade-out");
            element.classList.add("fade-in");
            if (scrollTo) element.scrollIntoView({
                behavior: "smooth",
                top: 0
            });
        }, milliseconds);
    }
    static delayedFadeOut(element, milliseconds = 0) {
        if (!element) return;
        setTimeout(()=>{
            element.classList.add("d-none");
            element.classList.remove("fade-in");
            element.classList.add("fade-out");
        }, milliseconds);
    }
    static delayedBlurIn(element, milliseconds = 0) {
        if (!element) return;
        setTimeout(()=>{
            element.classList.remove("blur-out");
            element.classList.add("blur-in");
        }, milliseconds);
    }
    static delayedBlurOut(element, milliseconds = 0) {
        if (!element) return;
        setTimeout(()=>{
            element.classList.remove("blur-in");
            element.classList.add("blur-out");
        }, milliseconds);
    }
}


class $15bf6a3816abfb50$export$d2ca453b913dcdea {
    static getParamValue(name) {
        return new URLSearchParams(window.location.search).get(name);
    }
    static timeFormatted(time = new Date().getTime()) {
        const hours = Math.floor(time / 1000 / 60 / 60);
        const minutes = Math.floor(time / 1000 / 60 % 60);
        const seconds = Math.floor(time / 1000 % 60);
        var timeString = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0");
        if (hours > 0) timeString = hours.toString().padStart(2, "0") + ":" + timeString;
        return timeString;
    }
    static getUserAgentData() {
        return UAParser();
    }
    static async getMediaDevices() {
        let result = [];
        if (!navigator.mediaDevices?.enumerateDevices) console.warn("enumerateDevices() not supported.");
        else // List cameras and microphones.
        await navigator.mediaDevices.enumerateDevices().then((devices)=>{
            devices.forEach((device)=>{
                result.push(device.label);
            });
        }).catch((err)=>{
            console.error(`${err.name}: ${err.message}`);
        });
        return result;
    }
    static map_range(value, low1, high1, low2, high2) {
        return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
    }
    static markdown(text) {
        marked.use({
            breaks: true
        });
        return DOMPurify.sanitize(marked.parse(text));
    }
}


class $40873ecf3c18e122$export$a8d6dd483a9ee681 {
    modalInfoElement;
    modalAlertElement;
    modalThanksElement;
    modalInfo;
    modalAlert;
    modalThanks;
    isInfoOpen;
    isAlertOpen;
    isThanksOpen;
    modalsQueue;
    constructor(modalInfoElement, modalAlertElement, modalThanksElement){
        this.isInfoOpen = false;
        this.isAlertOpen = false;
        this.isThanksOpen = false;
        this.modalInfoElement = modalInfoElement;
        this.modalAlertElement = modalAlertElement;
        this.modalThanksElement = modalThanksElement;
        this.modalInfo = new bootstrap.Modal(this.modalInfoElement, {});
        this.modalAlert = new bootstrap.Modal(this.modalAlertElement, {});
        this.modalThanks = new bootstrap.Modal(this.modalThanksElement, {});
        this.modalsQueue = [];
        this.setEvents();
    }
    // API :: INI
    info(message, callback = null) {
        this.addModalToQueue("info", message, callback);
    }
    alert(message, callback = null) {
        this.addModalToQueue("alert", message, callback);
    }
    thanks(callback = null) {
        this.addModalToQueue("thanks", "", callback);
    }
    // API :: END
    isOpen() {
        return this.isInfoOpen || this.isAlertOpen || this.isThanksOpen;
    }
    setEvents() {
        this.modalInfoElement.addEventListener("show.bs.modal", (event)=>{
            this.isInfoOpen = true;
        });
        this.modalInfoElement.addEventListener("hidden.bs.modal", (event)=>{
            this.isInfoOpen = false;
            this.modalClosed();
        });
        this.modalAlertElement.addEventListener("show.bs.modal", (event)=>{
            this.isAlertOpen = true;
        });
        this.modalAlertElement.addEventListener("hidden.bs.modal", (event)=>{
            this.isAlertOpen = false;
            this.modalClosed();
        });
        this.modalThanksElement.addEventListener("show.bs.modal", (event)=>{
            this.isThanksOpen = true;
        });
        this.modalThanksElement.addEventListener("hidden.bs.modal", (event)=>{
            this.isThanksOpen = false;
            this.modalClosed();
        });
    }
    showInfo(message, callback = null) {
        this.modalInfoElement.querySelector(".modal-body").innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(message);
        this.showModal(this.modalInfo, this.modalInfoElement, callback);
    }
    showAlert(message, callback = null) {
        this.modalAlertElement.querySelector(".modal-body").innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(message);
        this.showModal(this.modalAlert, this.modalAlertElement, callback);
    }
    showThanks(callback = null) {
        this.showModal(this.modalThanks, this.modalThanksElement, callback);
        setTimeout(()=>{
            party.confetti(this.modalThanksElement, {
                count: party.variation.range(100, 200)
            });
        }, 1000);
    }
    showByKind(kind, message, callback = null) {
        switch(kind){
            case "info":
                this.showInfo(message, callback);
                break;
            case "alert":
                this.showAlert(message, callback);
                break;
            case "thanks":
                this.showThanks(callback);
                break;
            default:
                throw new Error(`AppModal.show() kind not supported '${kind}'`);
        }
    }
    modalClosed() {
        this.nextModal();
    }
    addModalToQueue(kind, message, callback = null) {
        this.modalsQueue.push(new $40873ecf3c18e122$export$a8d6dd483a9ee681.ModalMessage(kind, message, callback));
        this.nextModal();
    }
    nextModal() {
        if (this.isOpen() || this.modalsQueue.length === 0) return;
        const nextModalMessage = this.modalsQueue.shift();
        this.showByKind(nextModalMessage.kind, nextModalMessage.message, nextModalMessage.callback);
    }
    static ModalMessage = class ModalMessage {
        kind;
        message;
        callback;
        constructor(kind, message, callback = null){
            this.kind = kind;
            this.message = message;
            this.callback = callback;
        }
    };
    showModal(modal, modalElement, callback = null) {
        modal.show();
        if (callback) {
            const abortController = new AbortController();
            modalElement.addEventListener("hide.bs.modal", ()=>{
                callback();
                abortController.abort();
            }, {
                signal: abortController.signal
            });
        }
    }
}



class $328c5552f35c9f1d$export$fe2589e86ee56365 {
    static modal = new (0, $40873ecf3c18e122$export$a8d6dd483a9ee681)(document.querySelector("#info-modal"), document.querySelector("#alert-modal"), document.querySelector("#thanks-modal"));
    static debug(message) {
        console.log(message, (new Error).stack.split("\n")[2].trim());
        try {
            (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent(message);
        } catch (error) {
            console.warn("Error sending DebugEvent", error);
        }
    }
    static info(message, callback = null) {
        console.log(message, (new Error).stack.split("\n")[2].trim());
        this.modal.info(message, callback);
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent(message);
    }
    static thanks(callback = null) {
        console.log("Thanks modal", (new Error).stack.split("\n")[2].trim());
        this.modal.thanks(callback);
    }
    static error(message, error) {
        console.error(message, error);
        let errorStack = "No Error.stack";
        if (error.stack) errorStack = error.stack.split("\n")[1].trim().replace("https", "").replace("http", "");
        const fullMessage = `
${message}

${error.message}

<small class="font-monospace fw-light text-secondary">${errorStack}</small>
`;
        this.modal.alert(fullMessage);
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent(fullMessage);
    }
}




class $d393c6b361322d0d$export$6955bcca4cd3539f {
    steps;
    developerRequirementsChecks;
    termsAndConditionsCheck;
    titlePortionElement;
    playGatheringInfoBlock;
    coverImgElement;
    titleElement;
    descriptionElement;
    playtestingRewardBlock;
    playtesterExpectationsBlock;
    playtestingSessionDurationBlock;
    fullGameplayDurationBlock;
    genresBlock;
    acceptPlaySessionButton;
    developerRequirementsBlock;
    extraInformationBlock;
    afterSessionInfo;
    afterThanksBlock;
    stepsSectionBlock;
    constructor({ playGathering: playGathering } = {}){
        this.playGathering = playGathering;
        // PlayGathering basic description
        this.titlePortionElement = document.querySelector("#title-portion");
        this.playGatheringInfoBlock = document.querySelector("#play-gathering-info-block");
        this.coverImgElement = document.querySelector("#play-gathering-cover-img");
        this.titleElement = document.querySelector("#play-gathering-title");
        this.descriptionElement = document.querySelector("#play-gathering-description");
        this.playtestingRewardBlock = document.querySelector("#play-gathering-playtesting-reward");
        this.playtesterExpectationsBlock = document.querySelector("#play-gathering-playtester-expectations");
        this.playtestingSessionDurationBlock = document.querySelector("#play-gathering-playtesting-session-duration");
        this.fullGameplayDurationBlock = document.querySelector("#play-gathering-full-gameplay-duration");
        this.genresBlock = document.querySelector("#play-gathering-genres");
        this.acceptPlaySessionButton = document.querySelector("#play-gathering-accept-play-session-button");
        this.developerRequirementsBlock = document.querySelector("#step-developer-requirements");
        this.extraInformationBlock = document.querySelector("#step-extra-information");
        this.afterSessionInfoBlock = document.querySelector("#step-after-session-info");
        this.afterThanksBlock = document.querySelector("#after-thanks");
        // Steps section
        this.steps = [];
        this.stepsSectionBlock = document.querySelector("#steps-section");
        this.stepDeveloperRequirements = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.developerRequirementsBlock, this.steps);
        this.stepExtraInformation = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.extraInformationBlock, this.steps);
        this.stepDownloadGame = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.stepsSectionBlock.querySelector("#step-download-game"), this.steps);
        this.stepTermsAndConditions = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.stepsSectionBlock.querySelector("#step-terms-and-conditions"), this.steps);
        this.stepRecordingRoom = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.stepsSectionBlock.querySelector("#step-recording-room"), this.steps);
        this.stepFinalThoughts = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.stepsSectionBlock.querySelector("#step-final-thoughts"), this.steps);
        this.stepAfterSessionInfo = new $d393c6b361322d0d$export$6955bcca4cd3539f.Step(this.afterSessionInfoBlock, this.steps);
        this.termsAndConditionsCheck = this.stepTermsAndConditions.block.querySelector("input[type=checkbox]");
    // // TODO: remove this
    // Effects.delayedFadeIn(this.stepsSectionBlock);
    // this.stepRecordingRoom.show();
    }
    checkIfPlayGatheringIsStillOpen() {
        if (this.playGathering.isFinished) {
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(document.querySelector(".container"));
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).info("This PlaySession is already closed. Thank you so much for your interest in helping us testing this game ;)", ()=>{
                this.afterThanks();
            });
            return false;
        } else return true;
    }
    init() {
        this.captureWindowErrors();
        this.setPageTitle();
        this.setEvents();
        this.setListeners();
        this.fillPlayGatheringInfo();
        this.showPlayGatheringInfo();
        this.scrollToTop(500);
    }
    setListeners() {
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).addListener("recording-session-finished", ()=>{
            this.recordingSessionFinished();
        });
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).addListener("final-thoughts-finished", ()=>{
            this.finalThoughtsFinished();
        });
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).addListener("all-steps-finished", ()=>{
            this.allStepsFinished();
        });
    }
    setEvents() {
        // I'm in button
        this.acceptPlaySessionButton.addEventListener("click", ()=>{
            this.showStepsSectionBlock();
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.acceptPlaySessionButton);
            this.steps[0].show(500);
        });
        // Extra information next button
        this.stepExtraInformation.block.querySelector(".next-button").addEventListener("click", ()=>{
            this.stepExtraInformation.hide(500);
            this.stepExtraInformation?.next().show(1000);
        });
        // Download game next button
        this.stepDownloadGame.block.querySelector(".next-button").addEventListener("click", ()=>{
            this.stepDownloadGame.hide(500);
            this.stepDownloadGame?.next().show(1000);
        });
        // Terms and conditions
        this.termsAndConditionsCheck.addEventListener("click", ()=>{
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("Terms and Conditions accepted");
            (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendSystemInfo();
            this.termsAndConditionsCheck.setAttribute("disabled", true);
            this.stepTermsAndConditions.hide(500);
            this.stepTermsAndConditions?.next().show(1000);
        });
        // After Session Done button
        this.stepAfterSessionInfo.block.querySelector(".next-button").addEventListener("click", ()=>{
            this.allStepsFinished();
        });
        // Window closes
        window.addEventListener("beforeunload", (event)=>{
            this.windowIsClosing(event);
        }, {
            capture: true
        });
    }
    setPageTitle() {
        document.title = "Playcocola is testing " + this.playGathering.title;
        this.titlePortionElement.innerHTML = this.playGathering.title;
    }
    showStepsSectionBlock() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.stepsSectionBlock, 100);
    }
    developerRequirementsCheckChecked() {
        this.stepDeveloperRequirements.block.querySelectorAll("input[type=checkbox]:checked").forEach((element)=>{
            element.setAttribute("disabled", true);
        });
        if (this.stepDeveloperRequirements.block.querySelectorAll("input[type=checkbox]:not(:checked)").length === 0) {
            this.stepDeveloperRequirements.hide();
            this.stepDeveloperRequirements?.next().show(500);
        }
    }
    fillPlayGatheringInfo() {
        // Basic
        if (this.playGathering.coverUrl) this.coverImgElement.src = this.playGathering.coverUrl;
        else {
            this.coverImgElement.remove();
            this.coverImgElement = null;
        }
        this.titleElement.innerHTML = this.playGathering.title;
        this.descriptionElement.innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(this.playGathering.description);
        if (this.playGathering.playtestingSessionMinutes) this.playtestingSessionDurationBlock.querySelector(".mins").innerHTML = this.playGathering.playtestingSessionMinutes;
        else {
            this.playtestingSessionDurationBlock.remove();
            this.playtestingSessionDurationBlock = null;
        }
        if (this.playGathering.fullGameplayMinutes) this.fullGameplayDurationBlock.querySelector(".mins").innerHTML = this.playGathering.fullGameplayMinutes;
        else {
            this.fullGameplayDurationBlock.remove();
            this.fullGameplayDurationBlock = null;
        }
        if (this.playGathering.playtesterReward) this.playtestingRewardBlock.querySelector(".card-text").innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(this.playGathering.playtesterReward || "");
        else {
            this.playtestingRewardBlock.remove();
            this.playtestingRewardBlock = null;
        }
        if (this.playGathering.playtesterExpectations) this.playtesterExpectationsBlock.querySelector(".card-text").innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(this.playGathering.playtesterExpectations || "");
        else {
            this.playtesterExpectationsBlock.remove();
            this.playtesterExpectationsBlock = null;
        }
        if (this.playGathering.genres.length !== 0) this.fillGenres(this.playGathering.genres);
        else {
            this.genresBlock.remove();
            this.genresBlock = null;
        }
        // Steps
        if (this.playGathering.requiredCheckboxes.length !== 0) this.fillDeveloperRequirements(this.playGathering.requiredCheckboxes);
        else {
            this.stepDeveloperRequirements.remove();
            this.stepDeveloperRequirements = null;
        }
        if (this.playGathering.gameBuildUrl) this.stepDownloadGame.stepContentElement.querySelector("a").href = this.playGathering.gameBuildUrl;
        else {
            this.stepDownloadGame.remove();
            this.stepDownloadGame = null;
        }
        if (this.playGathering.afterRequiredCheckboxesDescription) this.stepExtraInformation.setBody(this.playGathering.afterRequiredCheckboxesDescription);
        else {
            this.stepExtraInformation.remove();
            this.stepExtraInformation = null;
        }
        if (this.playGathering.afterSessionFinishedDescription) this.stepAfterSessionInfo.setBody(this.playGathering.afterSessionFinishedDescription);
        else {
            this.stepAfterSessionInfo.remove();
            this.stepAfterSessionInfo = null;
        }
    }
    fillGenres(genres) {
        const templateBadge = this.genresBlock.querySelector("span");
        this.genresBlock.innerHTML = "";
        genres.forEach((genre)=>{
            const newBadge = templateBadge.cloneNode(true);
            newBadge.innerHTML = genre;
            this.genresBlock.appendChild(newBadge);
            const space = document.createTextNode("\xa0");
            this.genresBlock.appendChild(space);
        });
    }
    fillDeveloperRequirements(requirements) {
        const templateCheck = this.stepDeveloperRequirements.stepContentElement.querySelector(".form-check");
        this.stepDeveloperRequirements.stepContentElement.innerHTML = "";
        requirements.forEach((requirement)=>{
            const id = crypto.randomUUID();
            const newCheck = templateCheck.cloneNode(true);
            newCheck.querySelector("input").id = id;
            newCheck.querySelector("label").htmlFor = id;
            newCheck.querySelector("label").innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(requirement);
            newCheck.querySelector("input").addEventListener("change", ()=>{
                this.developerRequirementsCheckChecked();
            });
            this.stepDeveloperRequirements.stepContentElement.appendChild(newCheck);
        });
    }
    // Show Elements :: INI
    showPlayGatheringInfo() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.playGatheringInfoBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.coverImgElement, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.titleElement, 600);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.descriptionElement, 800);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.playtestingSessionDurationBlock, 1000);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.fullGameplayDurationBlock, 1100);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.playtesterExpectationsBlock, 900);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.playtestingRewardBlock, 1500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.genresBlock, 750);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.acceptPlaySessionButton, 1800);
        this.makeLinksTargetBlank(this.descriptionElement);
        this.makeLinksTargetBlank(this.playtestingRewardBlock);
        this.makeLinksTargetBlank(this.developerRequirementsBlock);
        this.makeLinksTargetBlank(this.extraInformationBlock);
        this.makeLinksTargetBlank(this.afterSessionInfoBlock);
    }
    // Show Elements :: END
    captureWindowErrors() {
        window.addEventListener("error", function(errorEvent) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("An error was found :/", errorEvent.error);
        });
    }
    makeLinksTargetBlank(element) {
        if (!element) return;
        element.querySelectorAll("a").forEach((link)=>{
            link.setAttribute("target", "_blank");
        });
    }
    recordingSessionFinished() {
        this.stepRecordingRoom.hide();
        this.stepRecordingRoom?.next().show(500);
    }
    finalThoughtsFinished() {
        this.stepFinalThoughts.hide();
        this.stepFinalThoughts.next()?.show(500);
    }
    allStepsFinished() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(document.querySelector(".container"), 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.stepsSectionBlock, 2500);
        setTimeout(()=>{
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).thanks(()=>{
                this.afterThanks();
            });
        }, 2000);
    }
    afterThanks() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.playGatheringInfoBlock, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.afterThanksBlock, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurOut(document.querySelector(".container"), 1000);
        this.scrollToTop();
    }
    windowIsClosing(event) {
        console.log("WindowIsClosing()");
        if ((0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).uploader.isUploadingActive()) {
            event.preventDefault();
            return event.returnValue = "The video is currently uploading. Are you sure you want to close the window?";
        }
        if ((0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).recordingManager.isRecording) {
            event.preventDefault();
            return event.returnValue = "The recording is currently active. Are you sure you want to close the window?";
        }
    }
    scrollToTop(delayMilliseconds = 0) {
        setTimeout(()=>{
            document.querySelector("header").scrollIntoView({
                behavior: "smooth",
                top: 0
            });
        }, delayMilliseconds);
    }
    static Step = class Step {
        block;
        headerButtonElement;
        collapsableElement;
        stepContentElement;
        isRemoved;
        allSteps;
        collapsable;
        constructor(collapsableElement, allSteps){
            this.collapsableElement = collapsableElement;
            this.block = this.collapsableElement.closest(".accordion-item");
            this.headerButtonElement = this.block.querySelector(".accordion-header");
            this.stepContentElement = this.block.querySelector(".step-content");
            this.collapsable = bootstrap.Collapse.getOrCreateInstance(collapsableElement, {
                toggle: false
            });
            this.isRemoved = false;
            this.allSteps = allSteps;
            this.allSteps.push(this);
        }
        setBody(markdownText) {
            this.stepContentElement.innerHTML = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).markdown(markdownText);
        }
        show(delayMilliseconds = 0) {
            this.collapsable.show();
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.block, delayMilliseconds, true);
        }
        hide(delayMilliseconds = 0) {
            setTimeout(()=>{
                this.collapsable.hide();
            }, delayMilliseconds);
        }
        remove() {
            this.block.remove();
            const index = this.allSteps.indexOf(this);
            this.allSteps.splice(index, index !== -1 ? 1 : 0);
            this.isRemoved = true;
        }
        next() {
            const index = this.allSteps.indexOf(this);
            if (index + 1 === this.allSteps.length) {
                (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("all-steps-finished");
                return null;
            } else return this.allSteps[index + 1];
        }
    };
}




class $755e74551da6eee6$export$e2f9b2198337c39c {
    #playGatheringApiUrl;
    #apiToken;
    playGathering;
    constructor({ playGatheringApiUrl: playGatheringApiUrl, apiToken: apiToken } = {}){
        this.#playGatheringApiUrl = playGatheringApiUrl;
        this.#apiToken = apiToken;
    }
    async intPlayGathering() {
        try {
            const data = (await this.requestPlayGatheringInfo()).data;
            this.setPlayGathering(data);
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("On intPlayGathering()", error);
        }
    }
    setPlayGathering(data) {
        this.playGathering = {};
        this.playGathering.playSessionApiURL = data.play_session_api_url;
        this.playGathering.uuid = data.play_gathering.uuid;
        this.playGathering.title = data.play_gathering.title;
        this.playGathering.description = data.play_gathering.description;
        this.playGathering.playtesterExpectations = data.play_gathering.playtester_expectations;
        this.playGathering.coverUrl = data.play_gathering.cover_url;
        this.playGathering.playtestingSessionMinutes = data.play_gathering.playtesting_session_minutes;
        this.playGathering.fullGameplayMinutes = data.play_gathering.full_gameplay_minutes;
        this.playGathering.genres = data.play_gathering.genres;
        this.playGathering.playtesterReward = data.play_gathering.playtester_reward;
        this.playGathering.requiredCheckboxes = data.play_gathering.required_checkboxes;
        this.playGathering.afterRequiredCheckboxesDescription = data.play_gathering.after_required_checkboxes_description;
        this.playGathering.afterSessionFinishedDescription = data.play_gathering.after_session_finished_description;
        this.playGathering.gameBuildUrl = data.play_gathering.game_build_url;
        this.playGathering.isFinished = data.play_gathering.is_finished;
        this.playGathering.finishAt = data.play_gathering.finish_at;
    }
    // async requestPlayGatheringInfoMock() {
    //   const data = {};
    //   data.play_gathering = {};
    //   data.play_session_api_url = "PLAY_SESSION_API_URL";
    //   data.play_gathering.uuid = "UUID";
    //   data.play_gathering.title = "TITLE";
    //   data.play_gathering.description = "DESCRIPTION";
    //   data.play_gathering.cover_url = null;
    //   data.play_gathering.playtesting_session_minutes = null;
    //   data.play_gathering.full_gameplay_minutes = null;
    //   data.play_gathering.genres = [];
    //   data.play_gathering.playtester_reward = null;
    //   data.play_gathering.required_checkboxes = [];
    //   data.play_gathering.after_required_checkboxes_description = null;
    //   data.play_gathering.after_session_finished_description = null;
    //   data.play_gathering.game_build_url = null;
    //   return data;
    // }
    // async requestPlayGatheringInfoMock() {
    //   const data = {};
    //   data.play_gathering = {};
    //   data.play_session_api_url = "PLAY_SESSION_API_URL";
    //   data.play_gathering.uuid = "UUID";
    //   data.play_gathering.title = "TITLE";
    //   data.play_gathering.description = "DESCRIPTION";
    //   data.play_gathering.cover_url = "https://placehold.co/600x300";
    //   data.play_gathering.playtesting_session_minutes = 30;
    //   data.play_gathering.full_gameplay_minutes = 120;
    //   data.play_gathering.genres = ["genre_1", "genre_2"];
    //   data.play_gathering.playtester_reward = "PLAYTESTER_REWARD";
    //   data.play_gathering.required_checkboxes = ["check box **1**", "check box **3**"];
    //   data.play_gathering.after_required_checkboxes_description = "AFTER_REQUIRED_CHECKBOXES_DESCRIPTION";
    //   data.play_gathering.after_session_finished_description = "AFTER_SESSION_FINISHED_DESCRIPTION";
    //   data.play_gathering.game_build_url = "GAME_BUILD_URL";
    //   return data;
    // }
    requestPlayGatheringInfo() {
        return axios.request({
            method: "get",
            url: this.#playGatheringApiUrl,
            headers: this.#headers()
        });
    }
    sendDebugEvent(value) {
        let formData = new FormData();
        formData.append("tag", "client-action");
        formData.append("value", value);
        axios.request({
            method: "post",
            url: this.playGathering.playSessionApiURL + "/event",
            data: formData,
            headers: this.#headers()
        }).catch((error)=>{
            console.error("On sendDebugEvent()", error);
        });
    }
    async sendSystemInfo() {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("updateSystemInfo :: ini");
        let uaParserData = (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).getUserAgentData();
        let media_devices = await (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).getMediaDevices();
        let data = {
            user_agent: uaParserData,
            media_devices: media_devices
        };
        try {
            await axios.request({
                method: "post",
                data: data,
                url: this.playGathering.playSessionApiURL + "/update_system_info",
                headers: this.#headers()
            });
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("updateSystemInfo :: end");
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("updateSystemInfo :: error", error);
        }
    }
    async uploadVideoPart(date, blob, progressCallback = null) {
        const filename = "video_part_" + date + ".webm";
        const formData = new FormData();
        formData.append("video_part", blob, filename);
        await axios.request({
            method: "post",
            url: this.playGathering.playSessionApiURL + "/video_part",
            data: formData,
            headers: this.#headers(),
            onUploadProgress: (p)=>{
                // console.log("progress: ", p);
                if (progressCallback) progressCallback(p.progress);
            }
        });
    }
    async sendFinalThoughts(name, email, comment) {
        let formData = new FormData();
        formData.append("user_name", name);
        formData.append("user_email", email);
        formData.append("user_comment", comment);
        await axios.request({
            method: "post",
            url: this.playGathering.playSessionApiURL + "/comment",
            data: formData,
            headers: this.#headers()
        });
    }
    async sendSignalSessionFinalized() {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("sendSignalSessionFinalized :: ini");
        try {
            await axios.request({
                method: "post",
                url: this.playGathering.playSessionApiURL + "/session_finalized",
                headers: this.#headers()
            });
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("sendSignalSessionFinalized :: end");
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("sendSignalSessionFinalized :: error", error);
        }
    }
    async sendTimedComment(second_at_formatted, flair, comment) {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("sendTimedComment :: ini");
        let formData = new FormData();
        formData.append("second_at_formatted", second_at_formatted);
        formData.append("flair", flair);
        formData.append("comment", comment);
        await axios.request({
            method: "post",
            url: this.playGathering.playSessionApiURL + "/add_timed_comment",
            data: formData,
            headers: this.#headers()
        });
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("sendTimedComment :: end");
    }
    #headers() {
        return {
            "Authorization": "Playcocola " + this.#apiToken
        };
    }
}



class $475f92939529a454$export$b5fbdf7ba8f460df {
    #audioContext;
    #audioSource;
    #streamDataArray;
    #streamAnalyser;
    #definition;
    #streamBufferLength;
    constructor(audioContext, audioSource, definition = 32){
        this.#audioContext = audioContext;
        this.#audioSource = audioSource;
        this.#definition = definition;
        this.#streamAnalyser = this.#audioContext.createAnalyser();
        this.#audioSource.connect(this.#streamAnalyser);
        this.#streamAnalyser.fftSize = this.#definition; // use 2048 for big definition
        this.#streamBufferLength = this.#streamAnalyser.frequencyBinCount;
        this.#streamDataArray = new Uint8Array(this.#streamBufferLength);
    }
    getData() {
        this.#streamAnalyser.getByteTimeDomainData(this.#streamDataArray);
        return this.#streamDataArray;
    }
}


class $536aa4387b4a3908$export$44c0cd83afb91dc2 {
    screenStream = null;
    micStream = null;
    fullStream = null;
    micAudioTrack = null;
    screenVideoTrack = null;
    screenAudioTrack = null;
    fullAudioTrack = null;
    audioCtx = null;
    audioDestination = null;
    micAnalyzer;
    mimeType = null;
    recordedChunks = [];
    isMicActive = false;
    stopTimeoutID;
    isRecording;
    waitingForCloseStreams;
    constructor(){
        this.isRecording = false;
        this.waitingForCloseStreams = false;
    }
    resetStreams() {
        this.screenStream = null;
        this.micStream = null;
        this.fullStream = null;
        this.micAudioTrack = null;
        this.screenVideoTrack = null;
        this.screenAudioTrack = null;
        this.fullAudioTrack = null;
    }
    async initStreams() {
        if (this.screenStream === null) await this.initScreenStream();
        if (this.micStream === null && this.isMicActive) await this.initMicStream();
    }
    closeStreams() {
        console.log("SimpleRecorder.closeStreams()");
        if (this.getFullStream() != null) this.getFullStream().getTracks().forEach((track)=>track.stop());
        if (this.micStream != null) this.micStream.getTracks().forEach((track)=>track.stop());
        if (this.screenStream != null) this.screenStream.getTracks().forEach((track)=>track.stop());
        this.resetStreams();
    }
    resetMediaRecorder() {
        this.mediaRecorder = null;
    }
    // ScreenStream :: INI
    async initScreenStream() {
        try {
            this.screenStream = await navigator.mediaDevices.getDisplayMedia({
                video: {
                    height: {
                        max: 1080
                    }
                },
                audio: true
            });
            if (this.screenStream.getAudioTracks().length > 0) this.screenAudioTrack = this.screenStream.getAudioTracks()[0];
            else (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("initScreenStream - No Audio Tracks in the screenStream");
            if (this.screenStream.getVideoTracks().length > 0) this.screenVideoTrack = this.screenStream.getVideoTracks()[0];
            else throw new Error("No Video Tracks in the screenStream");
            console.log("initScreenStream - Success");
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("initScreenStream - Error: \n\nThere was a problem activating the screen capture. It may be caused for a security setting. Try to reset your screen capture settings for this domain.", error);
            throw error;
        }
    }
    // ScreenStream :: END
    // MicStream :: INI
    async initMicStream() {
        try {
            this.micStream = await navigator.mediaDevices.getUserMedia({
                video: false,
                audio: true
            });
            console.log("initMicStream - Success");
            if (this.micStream.getAudioTracks().length > 0) {
                this.micAudioTrack = this.micStream.getAudioTracks()[0];
                if (this.fullStream !== null) this.injectMicStreamIntoAudioDestination();
            } else throw new Error("No Audio Tracks in the micStream");
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("initMicStream - Error: \n\nThere was a problem activating the Mic. It may be caused for a security setting. Try to reset your mic settings for this domain.", error);
        }
    }
    async setMicActive(value) {
        this.isMicActive = value;
        if (value && this.micAudioTrack === null) await this.initMicStream();
        if (this.micAudioTrack !== null) this.micAudioTrack.enabled = value;
        else if (value) console.warn("SimpleRecorder.setMicActive() - No micAudioTrack found");
    }
    injectMicStreamIntoAudioDestination() {
        const streamSource = this.audioCtx.createMediaStreamSource(this.micStream);
        streamSource.connect(this.audioDestination);
        // Create analyser
        this.micAnalyzer = new (0, $475f92939529a454$export$b5fbdf7ba8f460df)(this.audioCtx, streamSource, 32);
    }
    // MicStream :: END
    // Silenced Audio Track :: INI
    injectSilencedAudioTrack() {
        const oscillator = this.audioCtx.createOscillator();
        const gainNode = this.audioCtx.createGain();
        gainNode.gain.value = 0;
        oscillator.connect(gainNode);
        gainNode.connect(this.audioDestination);
        oscillator.start();
    }
    // Silenced Audio Track :: END
    // MediaRecorder :: INI
    getFullStream() {
        console.log("getFullStream(): ", this.fullStream);
        if (this.fullStream !== null) return this.fullStream;
        // Create fullStream
        this.fullStream = new MediaStream();
        // Video Track
        if (this.screenVideoTrack !== null) this.fullStream.addTrack(this.screenVideoTrack);
        else {
            console.error("SimpleRecorder.getFullStream() - No Video Tracks in screenStream");
            APP.playcocolaAPI.sendDebugEvent("SimpleRecorder.getFullStream() - No Video Tracks in screenStream");
        }
        // create fullAudioTrack
        this.audioCtx = new AudioContext();
        this.audioDestination = this.audioCtx.createMediaStreamDestination();
        this.fullAudioTrack = this.audioDestination.stream.getAudioTracks()[0];
        // Screen Audio
        if (this.screenAudioTrack !== null) {
            console.log("AudioTracks in screenStream - Found");
            // const streamSource = this.audioCtx.createMediaStreamSource(this.screenStream);
            // streamSource.connect(this.audioDestination);
            // Reduce sound from screen audio:
            const gainNode = this.audioCtx.createGain();
            const streamSource = this.audioCtx.createMediaStreamSource(this.screenStream);
            streamSource.connect(gainNode);
            gainNode.connect(this.audioDestination);
            gainNode.gain.value = 0.1;
        } else console.log("AudioTracks in screenStream - No Found");
        // Mic Audio
        if (this.micAudioTrack !== null) this.injectMicStreamIntoAudioDestination();
        // Inject silenced audio track if not audio tracks found
        // This is a workaround for this bug in Chrome: https://bugs.chromium.org/p/chromium/issues/detail?id=1490888
        if (this.micAudioTrack === null && this.screenAudioTrack === null) this.injectSilencedAudioTrack();
        // Add the audioDestination fullAudioTrack to the full Stream.
        this.fullStream.addTrack(this.fullAudioTrack);
        return this.fullStream;
    }
    getMimeType() {
        if (this.mimeType !== null) return this.mimeType;
        const mimeTypes = [
            "video/webm;codecs=vp9",
            // "video/webm;codecs=vp8",
            // "video/webm;codecs=h264",
            // "video/webm;codecs=opus",
            // "video/x-matroska"
            "video/webm"
        ];
        const mimeTypeSupported = mimeTypes.find((e)=>MediaRecorder.isTypeSupported(e));
        if (mimeTypeSupported) {
            this.mimeType = mimeTypeSupported;
            console.log("Using mimeType: " + this.mimeType);
            return this.mimeType;
        } else {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("Not any mimeType supported. We recommend use another browser. Supported browsers are Chrome, Firefox and Edge.", new Error("Not any mimeType supported"));
            return null;
        }
    }
    initMediaRecorder() {
        this.mediaRecorder = new MediaRecorder(this.getFullStream(), {
            mimeType: this.getMimeType()
        });
        this.mediaRecorder.ondataavailable = (event)=>{
            this.onDataAvailable(event);
        };
    }
    onDataAvailable(event) {
        console.log("SimpleRecorder.onDataAvailable.size: ", event.data.size);
        this.recordedChunks.push(event.data);
    }
    // API :: INI
    record(seconds, shouldCloseStreamsOnFinish = false) {
        if (this.isRecording) {
            console.warn("SimpleRecorder.record when still instate isRecording");
            return;
        }
        if (this.mediaRecorder == undefined) this.initMediaRecorder();
        this.isRecording = true;
        this.recordedChunks = [];
        this.waitingForCloseStreams = shouldCloseStreamsOnFinish;
        return new Promise((resolve, reject)=>{
            this.mediaRecorder.onstop = ()=>{
                console.log("SimpleRecorder.onstop()");
                this.isRecording = false;
                const blob = this.crunchRecordedChunks();
                resolve(blob);
                if (this.waitingForCloseStreams) this.closeStreams();
            };
            this.mediaRecorder.onerror = (error)=>{
                (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("An error was detected while trying to record the video", error);
                this.isRecording = false;
                reject(error);
            };
            APP.playcocolaAPI.sendDebugEvent("SimpleRecorder.mediaRecorder.start()");
            try {
                this.mediaRecorder.start();
            } catch (error) {
                (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("An error was detected while starting to record the video", error);
                this.isRecording = false;
                reject(error);
            }
            if (this.isRecording) {
                console.log("SimpleRecorder.setting.timeout");
                this.stopTimeoutID = setTimeout(()=>{
                    console.log("SimpleRecorder.timeout");
                    this.mediaRecorder.stop();
                }, seconds * 1000);
            }
        });
    }
    stop(shouldCloseStreams = false) {
        if (!this.mediaRecorder) {
            console.warn("SimpleRecorder.stop() - mediaRecorder not found");
            return;
        }
        if (this.isRecording) {
            this.waitingForCloseStreams = shouldCloseStreams;
            clearTimeout(this.stopTimeoutID);
            this.mediaRecorder.stop();
        } else this.closeStreams();
    }
    // API :: END
    // MediaRecorder :: END
    crunchRecordedChunks() {
        // const fixedChunks = this.recordedChunks.splice(0, this.recordedChunks.length); // Fix bug in Chrome that generates corrupted blobs:
        const blob = new Blob(this.recordedChunks, {
            type: this.getMimeType()
        });
        return blob;
    }
}



class $9aaa049074615a4b$export$28754c0856e277c2 {
    recorder = null;
    videoElement = null;
    constructor(videoElement, recorder){
        this.videoElement = videoElement;
        this.recorder = recorder;
    }
    // API :: INI
    test(seconds, shouldCloseStreamsOnFinish = false) {
        this.showRecording();
        return new Promise((resolve, reject)=>{
            this.recorder.record(seconds, shouldCloseStreamsOnFinish).then((blob)=>{
                this.play(blob);
                resolve();
            }).catch((error)=>{
                (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("RecordingTester.test() - Error: ", error);
                reject(error);
            });
        });
    }
    // API :: END
    showRecording() {
        this.videoElement.srcObject = this.recorder.getFullStream();
        this.videoElement.muted = true;
        this.videoElement.play();
    }
    play(blob) {
        const videoURL = window.URL.createObjectURL(blob);
        this.videoElement.srcObject = null;
        this.videoElement.pause();
        this.videoElement.src = videoURL;
        this.videoElement.muted = false;
        this.videoElement.play();
    }
}
let $9aaa049074615a4b$var$recordingTester = null;
async function $9aaa049074615a4b$var$start() {
    const recorder = new SimpleRecorder();
    await recorder.initScreenStream();
    await recorder.initMicStream();
    recorder.initMediaRecorder();
    $9aaa049074615a4b$var$recordingTester = new $9aaa049074615a4b$export$28754c0856e277c2(document.querySelector("#video-wrapper video"), recorder);
    $9aaa049074615a4b$var$recordingTester.test();
} // start();



class $67b5ad8caac4e087$export$63b9018c3f271125 {
    isPaused = null;
    pausedAt = null;
    pausedTime = null;
    initAt = null;
    tickCallback = null;
    constructor(tickCallback = null){
        this.isPaused = true;
        this.pausedTime = 0;
        this.tickCallback = tickCallback;
    }
    start() {
        this.isPaused = false;
        this.initAt = this.getSystemTime();
        this.tick();
    }
    timeToString() {
        return (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).timeFormatted(this.getTime());
    }
    tick() {
        if (this.isPaused) return;
        if (this.tickCallback !== null) // console.log("this.tickCallback: ", this.tickCallback);
        this.tickCallback();
        setTimeout(()=>{
            this.tick();
        }, 1000);
    }
    pause() {
        this.isPaused = true;
        this.pausedAt = this.getSystemTime();
    }
    resume() {
        this.isPaused = false;
        this.pausedTime += this.getSystemTime() - this.pausedAt;
        this.tick();
    }
    getTime() {
        return this.getSystemTime() - this.initAt - this.pausedTime;
    }
    getSystemTime() {
        return new Date().getTime();
    }
}







class $fccf17475770b723$export$1ae9e0b6b419f0c4 {
    videoStatesBlock;
    videoStatePlayingBadge;
    videoStateRecordingBadge;
    videoStatePausedBadge;
    videoButtonsBlock;
    testRecordingButton;
    testReplayButton;
    startRecordingButton;
    recorderButtonsBlock;
    pauseButton;
    resumeButton;
    finishRecordingButton;
    videoMiniControlsBlock;
    micCheck;
    micCheckBlock;
    micPopover;
    commentButton;
    timerDisplay;
    uploadingProgressBlock;
    videoElement;
    timer;
    isRecordingPaused;
    isMicActive;
    isSessionFinished;
    isRecording;
    recorder;
    recordingTester;
    micAnimationIntervalID;
    // videoSettingsTrackIntervalID
    TESTING_SECONDS;
    VIDEO_BLOCK_SECONDS;
    constructor(){
        this.TESTING_SECONDS = 10;
        this.VIDEO_BLOCK_SECONDS = 60; // TODO back to 60
        this.videoStatesBlock = document.querySelector("#video-state-badges");
        this.videoStatePlayingBadge = document.querySelector("#video-state-playing-badge");
        this.videoStateRecordingBadge = document.querySelector("#video-state-recording-badge");
        this.videoStatePausedBadge = document.querySelector("#video-state-paused-badge");
        this.videoButtonsBlock = document.querySelector("#video-buttons-wrapper");
        this.testRecordingButton = document.querySelector("#test-recording-button");
        this.testReplayButton = document.querySelector("#test-replay-button");
        this.startRecordingButton = document.querySelector("#start-recording-button");
        this.recorderButtonsBlock = document.querySelector("#recorder-buttons");
        this.pauseButton = document.querySelector("#pause-button");
        this.resumeButton = document.querySelector("#resume-button");
        this.finishRecordingButton = document.querySelector("#finish-recording-button");
        this.videoMiniControlsBlock = document.querySelector("#video-mini-controls");
        this.micCheck = document.querySelector("#mic-check");
        this.micCheckBlock = document.querySelector("#mic-check-wrapper");
        this.micPopover = bootstrap.Popover.getOrCreateInstance("#mic-check-wrapper");
        this.commentButton = document.querySelector("#timed-comment-button");
        this.timerDisplay = document.querySelector("#timer-display");
        this.timedCommentTimerDisplay = document.querySelector("#timed-comment-timer-display");
        this.uploadingProgressBlock = document.querySelector("#uploading-progress-block");
        this.videoElement = document.querySelector("#video-wrapper video");
        this.videoElement.controls = false;
        this.isMicActive = this.micCheck.checked;
        this.isRecordingPaused = false;
        this.isSessionFinished = false;
        this.isRecording = false;
        this.recorder = new (0, $536aa4387b4a3908$export$44c0cd83afb91dc2)();
        this.recordingTester = new (0, $9aaa049074615a4b$export$28754c0856e277c2)(this.videoElement, this.recorder);
        this.testRecordingVideoEventsController = new AbortController();
        this.setMicActive(false);
        this.timer = new (0, $67b5ad8caac4e087$export$63b9018c3f271125)(()=>{
            this.timerTick();
        });
        this.setListeners();
        this.setEvents();
    // // TODO: remove this
    // this.videoSettingsTrackStart();
    }
    setListeners() {
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).addListener("timed-comment-toggle-recording-pause", (value)=>{
            this.askingForPause(value);
        });
    }
    setEvents() {
        this.testRecordingButton.addEventListener("click", (event)=>{
            this.testRecording();
        });
        this.testReplayButton.addEventListener("click", (event)=>{
            this.videoElement.play();
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStatePlayingBadge, 0);
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.micCheckBlock, 0);
        });
        this.micCheck.addEventListener("change", (event)=>{
            this.setMicActive(this.micCheck.checked);
        });
        this.startRecordingButton.addEventListener("click", (event)=>{
            console.log("startRecordingButton.click()");
            this.startRecording();
        });
        this.pauseButton.addEventListener("click", (event)=>{
            this.pauseRecording();
        });
        this.resumeButton.addEventListener("click", (event)=>{
            this.resumeRecording();
        });
        this.finishRecordingButton.addEventListener("click", (event)=>{
            this.finishRecording();
        });
    }
    async initStreams() {
        await this.recorder.initStreams();
    }
    async testRecording() {
        this.recorder.resetStreams();
        this.recorder.resetMediaRecorder();
        await this.initStreams();
        // Add testing recording video events
        this.videoElement.addEventListener("ended", (event)=>{
            this.testRecordingVideoFinished();
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStatePlayingBadge);
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStateRecordingBadge);
            if (document.fullscreenElement) document.exitFullscreen();
        }, {
            signal: this.testRecordingVideoEventsController.signal
        });
        this.videoElement.addEventListener("play", (event)=>{
            this.testRecordingVideoPlaying();
        }, {
            signal: this.testRecordingVideoEventsController.signal
        });
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStateRecordingBadge, 0);
        this.videoElement.removeAttribute("controls");
        this.timer.start();
        this.recordingTester.test(this.TESTING_SECONDS, true).then(()=>{
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStatePlayingBadge, 0);
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStateRecordingBadge, 0);
            (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.micCheckBlock, 0);
            this.videoElement.setAttribute("controls", true);
        }).catch((error)=>{
            (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent("RecordingManager.testRecording() - Error: ", error);
            this.onErrorOnRecording(error);
        }).finally(()=>{
            this.timer.pause();
        });
    }
    testRecordingVideoPlaying() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoButtonsBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurOut(this.videoElement);
    }
    testRecordingVideoFinished() {
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.testReplayButton);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoButtonsBlock, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.micCheckBlock, 1000);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(this.videoElement, 500);
    }
    setMicActive(value) {
        console.log("App.setMicActive(): ", value);
        this.micCheck.checked = value;
        this.isMicActive = value;
        this.recorder.setMicActive(value);
        this.updateMicPopover();
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("Mic Activation: " + value);
        if (value) this.micAnimationStart();
        else this.micAnimationStop();
    }
    timerTick(timer) {
        this.timerDisplay.innerHTML = this.timer.timeToString();
        this.timedCommentTimerDisplay.innerHTML = this.timer.timeToString();
    }
    onErrorOnRecording(error) {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("RecordingManager.onErrorOnRecording()", error);
        this.isRecording = false;
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoButtonsBlock, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(this.videoElement, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.commentButton, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.recorderButtonsBlock, 1000);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStateRecordingBadge);
        this.timer.pause();
        this.videoElement.pause();
    }
    async startRecording() {
        try {
            this.recorder.resetStreams();
            this.recorder.resetMediaRecorder();
            await this.initStreams();
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("There was an error trying to record the screen", error);
            return;
        }
        this.sendTracksInfo();
        this.isRecording = true;
        // Remove testing recording video events
        this.testRecordingVideoEventsController.abort();
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoButtonsBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurOut(this.videoElement);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.commentButton, 500);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.recorderButtonsBlock, 1000);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStateRecordingBadge);
        this.timer.start();
        this.videoElement.srcObject = this.recorder.getFullStream();
        this.videoElement.muted = true;
        this.videoElement.controls = false;
        this.videoElement.play();
        this.recordVideoBlock();
    }
    recordVideoBlock() {
        this.recorder.record(this.VIDEO_BLOCK_SECONDS).then((blob)=>{
            this.newVideoBlock(blob);
            if (!this.isRecordingPaused && !this.isSessionFinished) this.recordVideoBlock();
        }).catch((error)=>{
            (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent("RecordingManager.recordVideoBlock() - Error: ", error);
            this.onErrorOnRecording(error);
        });
    }
    newVideoBlock(blob) {
        console.log("RecordingManager.newVideoBlock().blob.size: ", blob.size);
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent("RecordingManager.newVideoBlock().blob.size: " + blob.size);
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).uploader.addBlobToUploadQueue(blob);
    }
    pauseRecording() {
        if (this.isRecordingPaused) return;
        this.isRecordingPaused = true;
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent("RecordingManager.pauseRecording()");
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStateRecordingBadge);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStatePausedBadge, 100);
        this.pauseButton.setAttribute("disabled", true);
        this.resumeButton.removeAttribute("disabled");
        this.timer.pause();
        this.recorder.stop();
        this.videoElement.pause();
        this.micAnimationStop();
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(this.videoElement, 500);
    }
    resumeRecording() {
        if (!this.isRecordingPaused) return;
        this.isRecordingPaused = false;
        (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendDebugEvent("RecordingManager.resumeRecording()");
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.videoStateRecordingBadge, 100);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStatePausedBadge);
        this.pauseButton.removeAttribute("disabled");
        this.resumeButton.setAttribute("disabled", true);
        this.timer.resume();
        this.videoElement.play();
        this.recordVideoBlock();
        if (this.isMicActive) this.micAnimationStart();
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurOut(this.videoElement, 200);
    }
    finishRecording() {
        if (!confirm("Please confirm you want to finish the session")) return;
        this.isRecording = false;
        this.isSessionFinished = true;
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoStatesBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoMiniControlsBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.videoButtonsBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.recorderButtonsBlock);
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedBlurIn(this.videoElement, 200);
        this.timer.pause();
        this.recorder.stop(true);
        this.videoElement.pause();
        // Wait a bit to allow recorder to generate the last blob
        setTimeout(()=>{
            if ((0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).uploader.isUploadingActive()) (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).uploader.onUploadsFinishedCallback = ()=>{
                (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendSignalSessionFinalized();
            };
            else (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendSignalSessionFinalized();
        }, 500);
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("recording-session-finished");
    }
    askingForPause(value) {
        console.log("askingForPause: ", value);
        if (value) this.pauseRecording();
        else this.resumeRecording();
    }
    updateMicPopover() {
        if (this.micCheck.checked) this.micPopover.setContent({
            ".popover-body": "Mic is active, click to deactivate it."
        });
        else this.micPopover.setContent({
            ".popover-body": "Mic is deactivated, click to activate it."
        });
    }
    // Mic Animation :: INI
    micAnimation() {
        if (this.recorder.micAnalyzer) {
            const data = this.recorder.micAnalyzer.getData();
            const max = Math.max(...data);
            const min = Math.min(...data);
            const valueMax = Math.abs(128 - max);
            const valueMin = Math.abs(128 - min);
            const value = Math.max(valueMin, valueMax);
            const scale = Math.min((0, $15bf6a3816abfb50$export$d2ca453b913dcdea).map_range(value, 0, 10, 1, 1.5), 1.5);
            this.micCheckBlock.style.transform = `scale(${scale},${scale})`;
        }
    }
    micAnimationStart() {
        this.micAnimationIntervalID = setInterval(()=>{
            this.micAnimation();
        }, 300);
    }
    micAnimationStop() {
        this.micCheckBlock.style.transform = `scale(1,1)`;
        clearInterval(this.micAnimationIntervalID);
    }
    // Mic Animation :: END
    sendTracksInfo() {
        if (this.recorder.screenVideoTrack) (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("screenVideoTrack: " + JSON.stringify(this.recorder.screenVideoTrack.getSettings()));
        else (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("No screenVideoTrack");
        if (this.recorder.screenAudioTrack) (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("screenAudioTrack: " + JSON.stringify(this.recorder.screenAudioTrack.getSettings()));
        else (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("No screenAudioTrack");
        if (this.recorder.micAudioTrack) (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("micAudioTrack: " + JSON.stringify(this.recorder.micAudioTrack.getSettings()));
        else (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("No micAudioTrack");
    }
}





class $724ac115a423ec31$export$b4ba47569ccac746 {
    #progressBlock;
    #progressElement;
    #progressBarElement;
    #uploadsQueueCounterElement;
    #blogsToUploadQueue;
    #isUploading;
    #isRecoveringFromError;
    #lastUploadPercentageDebugEvent;
    onUploadsFinishedCallback;
    constructor(){
        this.#blogsToUploadQueue = [];
        this.#isUploading = false;
        this.#isRecoveringFromError = false;
        this.#progressBlock = document.querySelector("#uploading-progress-block");
        this.#progressElement = this.#progressBlock.querySelector(".progress");
        this.#progressBarElement = this.#progressBlock.querySelector(".progress-bar");
        this.#uploadsQueueCounterElement = document.querySelector("#uploads-queue-counter");
        this.#lastUploadPercentageDebugEvent = 0;
        this.onUploadsFinishedCallback = null;
    }
    // API :: INI
    addBlobToUploadQueue(blob, date = Date.now(), retries_counter = 0) {
        this.#blogsToUploadQueue.push(new $724ac115a423ec31$export$b4ba47569ccac746.BlobToUpload(blob, date, retries_counter));
        this.#updateUploadQueueCounter();
        this.#uploadNextBlob();
        console.log("addBlobToUploadQueue().#blogsToUploadQueue.length: ", this.#blogsToUploadQueue.length);
    }
    isUploadingActive() {
        return this.#isUploading || this.#isRecoveringFromError;
    }
    // API :: END
    async #uploadVideoPart(video_part_data) {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("uploadVideoPart :: ini");
        (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.#progressBlock);
        this.#isUploading = true;
        this.#uploadProgressBarUpdate(0);
        try {
            await (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.uploadVideoPart(video_part_data.date, video_part_data.blob, (value)=>{
                this.#uploadProgressBarUpdate(value);
            });
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("uploadVideoPart :: end");
            if (this.#blogsToUploadQueue.length === 0) this.onUploadsFinishedCallback?.();
            this.#isUploading = false;
            this.#uploadNextBlob();
        } catch (error) {
            const error_message = error.response?.data?.error || "Error uploading the video";
            const retrievable = error.response?.data?.retrievable !== undefined ? error.response?.data?.retrievable : true;
            console.log("#uploadVideoPart.error.retrievable: ", retrievable);
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error(error_message, error);
            this.#isUploading = false;
            // Sending it back to the queue
            if (retrievable) {
                console.log("#uploadVideoPart.error.retrying");
                this.addBlobToUploadQueue(video_part_data.blob, video_part_data.date, video_part_data.retries_counter + 1);
                this.#isRecoveringFromError = true;
                // Wait X seconds
                setTimeout(()=>{
                    this.#isRecoveringFromError = false;
                    this.#uploadNextBlob();
                }, 20000);
            } else this.#uploadNextBlob();
        } finally{
            this.#updateUploadQueueCounter();
        }
    }
    #uploadProgressBarUpdate(percentage) {
        if (percentage > this.#lastUploadPercentageDebugEvent + 0.05 || percentage < this.#lastUploadPercentageDebugEvent) {
            this.#lastUploadPercentageDebugEvent = percentage;
            this.#progressElement.setAttribute("aria-valuenow", percentage * 100);
            this.#progressBarElement.style.width = percentage * 100 + "%";
        }
    }
    #uploadNextBlob() {
        console.log("#uploadNextBlob()");
        if (this.isUploadingActive() || this.#blogsToUploadQueue.length === 0) return;
        const video_part_data = this.#blogsToUploadQueue.shift();
        this.#uploadVideoPart(video_part_data);
        this.#updateUploadQueueCounter();
    }
    #updateUploadQueueCounter() {
        if (this.isUploadingActive()) (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeIn(this.#progressBlock);
        else (0, $002442a081a20f94$export$af73ab700e00763e).delayedFadeOut(this.#progressBlock);
        this.#uploadsQueueCounterElement.innerHTML = this.#blogsToUploadQueue.length + 1;
    }
    static BlobToUpload = class BlobToUpload {
        blob;
        date;
        retries;
        constructor(blob, date = Date.now(), retries = 0){
            this.blob = blob;
            this.date = date;
            this.retries = retries;
        }
    };
}





class $cffc704115b09ad4$export$e92e0c0c91981c77 {
    #form;
    #cancelButton;
    #submitButton;
    #rememberInfoCheck;
    constructor(){
        this.#form = document.querySelector("#final-thoughts-form");
        this.#cancelButton = document.querySelector("#final-thoughts-cancel-button");
        this.#submitButton = document.querySelector("#final-thoughts-submit-button");
        this.#rememberInfoCheck = document.querySelector("#final-thoughts-remember-info-check");
        this.#setEvents();
        this.#checkIfInfoIsRemembered();
        this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
    }
    // API :: INI
    sendInfoIfAlreadyRemembered() {
        if (this.#form.querySelector("#final-thoughts-name").value !== "" || this.#form.querySelector("#final-thoughts-email").value !== "") this.#sendFormInfo();
    }
    // API :: END
    async #setEvents() {
        this.#form.addEventListener("submit", (event)=>{
            this.#onFormSubmit(event);
        });
        this.#rememberInfoCheck.addEventListener("change", (event)=>{
            this.#rememberOrForgetInfo();
        });
        this.#cancelButton.addEventListener("click", (event)=>{
            (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("final-thoughts-finished");
        });
        this.#form.querySelectorAll(".form-control").forEach((element)=>{
            element.addEventListener("input", (event)=>{
                this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
            });
        });
    }
    #disableSubmitButton() {
        this.#submitButton.setAttribute("disabled", true);
    }
    #enableSubmitButton() {
        this.#submitButton.removeAttribute("disabled");
    }
    async #onFormSubmit(event) {
        event.preventDefault();
        this.#disableSubmitButton();
        this.#rememberOrForgetInfo();
        try {
            await this.#sendFormInfo();
            (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("final-thoughts-finished");
        } catch (error) {
            this.#enableSubmitButton();
        }
    }
    async #sendFormInfo() {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("FinalThoughtsFormSend :: ini");
        const name = this.#form.querySelector("#final-thoughts-name").value;
        const email = this.#form.querySelector("#final-thoughts-email").value;
        const comment = this.#form.querySelector("#final-thoughts-comment").value;
        try {
            await (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendFinalThoughts(name, email, comment);
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("FinalThoughtsFormSend :: end");
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("FinalThoughtsFormSend :: error", error);
            throw error;
        }
    }
    #checkIfInfoIsRemembered() {
        if (Cookies.get("name") != undefined && Cookies.get("name") != "") this.#form.querySelector("#final-thoughts-name").value = Cookies.get("name");
        if (Cookies.get("email") != undefined && Cookies.get("email") != "") this.#form.querySelector("#final-thoughts-email").value = Cookies.get("email");
        if (Cookies.get("remember") != undefined) this.#rememberInfoCheck.checked = true;
    }
    #rememberOrForgetInfo() {
        const checked = this.#rememberInfoCheck.checked;
        if (checked) {
            Cookies.set("name", this.#form.querySelector("#final-thoughts-name").value, {
                expires: 90
            });
            Cookies.set("email", this.#form.querySelector("#final-thoughts-email").value, {
                expires: 90
            });
            Cookies.set("remember", true, {
                expires: 90
            });
        } else {
            Cookies.remove("name");
            Cookies.remove("email");
            Cookies.remove("remember");
        }
    }
    #checkIfSubmitButtonShouldBeEnabledOrDisabled() {
        let result = Array(...this.#form.querySelectorAll(".form-control")).some((element)=>{
            return element.value.trim() !== "";
        });
        if (result) this.#enableSubmitButton();
        else this.#disableSubmitButton();
    }
}





class $1a00d36ff926ff9c$export$f24ae1eab475e860 {
    #modalElement;
    #form;
    #submitButton;
    #pauseRecordingCheck;
    #modal;
    constructor(){
        this.#modalElement = document.querySelector("#timed-comment-modal");
        this.#form = document.querySelector("#timed-comment-form");
        this.#submitButton = this.#form.querySelector("button[type=submit]");
        this.#pauseRecordingCheck = document.querySelector("#timed-comment-pause-recording-check");
        this.#modal = new bootstrap.Modal(this.#modalElement, {});
        this.#setEvents();
        this.#checkIfPauseRecordingChecked();
        this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
    }
    async #setEvents() {
        this.#form.addEventListener("submit", (event)=>{
            this.#formSend(event);
        });
        this.#pauseRecordingCheck.addEventListener("change", (event)=>{
            this.#togglePauseRecording(this.#pauseRecordingCheck.checked);
        });
        this.#form.querySelector("#timed-comment-comment").addEventListener("input", (event)=>{
            this.#checkIfSubmitButtonShouldBeEnabledOrDisabled();
        });
        this.#modalElement.addEventListener("hidden.bs.modal", (event)=>{
            this.#modalClosed();
        });
        this.#modalElement.addEventListener("show.bs.modal", (event)=>{
            this.#modalOpened();
        });
    }
    #modalOpened() {
        this.#togglePauseRecording(this.#pauseRecordingCheck.checked);
    }
    #modalClosed() {
        if (this.#pauseRecordingCheck.checked) (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("timed-comment-toggle-recording-pause", false);
    }
    #closeModal() {
        this.#modal.hide();
    }
    #disableSubmitButton() {
        this.#submitButton.setAttribute("disabled", true);
    }
    #enableSubmitButton() {
        this.#submitButton.removeAttribute("disabled");
    }
    async #formSend(event) {
        (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("TimedCommentFormSend :: ini");
        event.preventDefault();
        this.#disableSubmitButton();
        const second_at_formatted = document.querySelector("#timed-comment-timer-display").innerHTML.trim();
        const flair = this.#form.querySelector("input[name=flair]:checked").value;
        const comment = this.#form.querySelector("#timed-comment-comment").value;
        try {
            await (0, $7e6258f3559d0f34$export$c3d83ca6855fa0d0).playcocolaAPI.sendTimedComment(second_at_formatted, flair, comment);
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).debug("TimedCommentFormSend :: end");
            this.#closeModal();
            this.#form.querySelector("#timed-comment-comment").value = "";
        } catch (error) {
            (0, $328c5552f35c9f1d$export$fe2589e86ee56365).error("TimedCommentFormSend :: error", error);
        }
    }
    #checkIfPauseRecordingChecked() {
        this.#pauseRecordingCheck.checked = Cookies.get("pause-recording-while-commenting") == "true";
    }
    #togglePauseRecording(value) {
        Cookies.set("pause-recording-while-commenting", value);
        (0, $5c3ab28d7e637dfc$export$5087227eb54526).event("timed-comment-toggle-recording-pause", value);
    }
    #checkIfSubmitButtonShouldBeEnabledOrDisabled() {
        let result = this.#form.querySelector("#timed-comment-comment").value.trim() !== "";
        if (result) this.#enableSubmitButton();
        else this.#disableSubmitButton();
    }
}



class $7e6258f3559d0f34$var$App {
    modal;
    page;
    messageBus;
    uploader;
    finalThoughts;
    timedComment;
    playcocolaAPI;
    recordingManager;
    constructor(){}
    async init() {
        this.initPopovers();
        this.initRecordingManager();
        this.initUploader();
        this.initFinalThoughts();
        this.initTimedComment();
        await this.initPlaycocolaAPI();
        this.initPage();
        this.finalThoughts.sendInfoIfAlreadyRemembered();
    }
    initUploader() {
        this.uploader = new (0, $724ac115a423ec31$export$b4ba47569ccac746)();
    }
    async initPlaycocolaAPI() {
        this.playcocolaAPI = new (0, $755e74551da6eee6$export$e2f9b2198337c39c)({
            playGatheringApiUrl: (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).getParamValue("play_gathering_api_url"),
            apiToken: (0, $15bf6a3816abfb50$export$d2ca453b913dcdea).getParamValue("api_token")
        });
        await this.playcocolaAPI.intPlayGathering();
    }
    initPage() {
        this.page = new (0, $d393c6b361322d0d$export$6955bcca4cd3539f)({
            playGathering: this.playcocolaAPI.playGathering
        });
        if (this.page.checkIfPlayGatheringIsStillOpen()) this.page.init();
    }
    initPopovers() {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        const popoverList = [
            ...popoverTriggerList
        ].map((popoverTriggerEl)=>new bootstrap.Popover(popoverTriggerEl));
    }
    initRecordingManager() {
        this.recordingManager = new (0, $fccf17475770b723$export$1ae9e0b6b419f0c4)();
    }
    initFinalThoughts() {
        this.finalThoughts = new (0, $cffc704115b09ad4$export$e92e0c0c91981c77)();
    }
    initTimedComment() {
        this.timedComment = new (0, $1a00d36ff926ff9c$export$f24ae1eab475e860)();
    }
}
const $7e6258f3559d0f34$export$c3d83ca6855fa0d0 = new $7e6258f3559d0f34$var$App();
$7e6258f3559d0f34$export$c3d83ca6855fa0d0.init();
window.APP = $7e6258f3559d0f34$export$c3d83ca6855fa0d0;

})();
//# sourceMappingURL=index.262ca7c9.js.map
